(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (()=>{const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;if(reduce)return;
const start=e=>{if(e.type==='pointerover'&&!matchMedia('(hover:hover)').matches)return;const card=e.target.closest('.card-gallery');if(!card||card.contains(e.relatedTarget))return;const v=card.querySelector('[data-dd-hover-video]');if(!v)return;if(!v.src)v.src=v.dataset.ddHoverVideo;v.muted=true;v.play().then(()=>card.classList.add('dd-video-playing')).catch(()=>{});};
const stop=e=>{const card=e.target.closest('.card-gallery');if(!card||card.contains(e.relatedTarget))return;const v=card.querySelector('[data-dd-hover-video]');if(v){v.pause();card.classList.remove('dd-video-playing');}};
document.addEventListener('pointerover',start);document.addEventListener('pointerout',stop);document.addEventListener('focusin',start);document.addEventListener('focusout',stop);
document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-dd-hover-video]').forEach(v=>{v.pause();v.closest('.card-gallery').classList.remove('dd-video-playing')})});})();
  } catch(e) { console.error(e); }
})();

})();
